import React, { useState } from 'react';
import { 
  FiBell, 
  FiAlertTriangle, 
  FiInfo, 
  FiCheck, 
  FiArchive,
  FiClock,
  FiTrendingDown,
  FiUsers
} from 'react-icons/fi';

const Notifications = () => {
  const [activeTab, setActiveTab] = useState('unread'); // all, unread, archived

  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc',
    text: '#333333'
  };

  // Mock Notification Data
  const notifications = [
    {
      id: 1,
      type: 'warning',
      message: 'इनाम धामणी ग्रामपंचायतीचे ५ अर्ज ७ दिवसांपासून प्रलंबित आहेत.',
      gp: 'इनाम धामणी',
      date: '२०/०२/२०२६',
      time: '१०:०० सकाळी',
      status: 'unread'
    },
    {
      id: 2,
      type: 'critical',
      message: 'बेडग ग्रामपंचायतीचा महसूल वसुली दर ५०% पेक्षा कमी झाला आहे.',
      gp: 'बेडग',
      date: '१९/०२/२०२६',
      time: '०४:३० दुपारी',
      status: 'unread'
    },
    {
      id: 3,
      type: 'info',
      message: 'नवीन शासन निर्णय (GR) सिस्टममध्ये अपडेट करण्यात आला आहे.',
      gp: 'सर्व',
      date: '१८/०२/२०२६',
      time: '११:१५ सकाळी',
      status: 'read'
    },
    {
      id: 4,
      type: 'system',
      message: 'उद्या रात्री १०:०० वाजता सिस्टम मेंटेनन्स नियोजित आहे.',
      gp: 'System',
      date: '१८/०२/२०२६',
      time: '०९:०० सकाळी',
      status: 'archived'
    }
  ];

  const getIcon = (type) => {
    switch(type) {
      case 'critical': return <FiAlertTriangle className="text-red-500" />;
      case 'warning': return <FiClock className="text-orange-500" />;
      case 'system': return <FiInfo className="text-blue-500" />;
      default: return <FiBell className="text-gray-500" />;
    }
  };

  const getBorderColor = (type) => {
    switch(type) {
      case 'critical': return 'border-red-500';
      case 'warning': return 'border-orange-500';
      case 'system': return 'border-blue-500';
      default: return 'border-gray-300';
    }
  };

  const filteredNotifications = notifications.filter(n => {
    if (activeTab === 'all') return n.status !== 'archived';
    if (activeTab === 'unread') return n.status === 'unread';
    if (activeTab === 'archived') return n.status === 'archived';
    return true;
  });

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>सूचना आणि इशारे (Notifications & Alerts)</h1>
        <p className="text-gray-600 text-sm">प्रलंबित कामे आणि महत्वाच्या सूचनांवर लक्ष ठेवा.</p>
      </div>

      {/* Critical Alert Cards */}
      <h2 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
        <FiAlertTriangle className="mr-2 text-red-600" /> महत्वाचे इशारे (Priority Alerts)
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        <div className="bg-red-50 p-4 rounded-xl border border-red-100 flex items-start gap-3">
          <div className="bg-red-100 p-2 rounded-lg text-red-600 mt-1">
             <FiClock size={20} />
          </div>
          <div>
            <div className="font-bold text-red-800 text-lg">१२ अर्ज</div>
            <div className="text-red-600 text-sm font-medium">७+ दिवसांपासून प्रलंबित</div>
            <div className="text-red-400 text-xs mt-1">ताबडतोब कृती करा</div>
          </div>
        </div>

        <div className="bg-orange-50 p-4 rounded-xl border border-orange-100 flex items-start gap-3">
          <div className="bg-orange-100 p-2 rounded-lg text-orange-600 mt-1">
             <FiTrendingDown size={20} />
          </div>
          <div>
            <div className="font-bold text-orange-800 text-lg">३ गावे</div>
            <div className="text-orange-600 text-sm font-medium">कमी महसूल वसुली</div>
            <div className="text-orange-400 text-xs mt-1">अहवाल तपासा</div>
          </div>
        </div>

        <div className="bg-yellow-50 p-4 rounded-xl border border-yellow-100 flex items-start gap-3">
          <div className="bg-yellow-100 p-2 rounded-lg text-yellow-600 mt-1">
             <FiUsers size={20} />
          </div>
          <div>
            <div className="font-bold text-yellow-800 text-lg">५ लॉगिन्स</div>
            <div className="text-yellow-600 text-sm font-medium">३० दिवसांपासून निष्क्रिय</div>
            <div className="text-yellow-500 text-xs mt-1">खाते आढावा घ्या</div>
          </div>
        </div>
        
        <div className="bg-blue-50 p-4 rounded-xl border border-blue-100 flex items-start gap-3">
           <div className="bg-blue-100 p-2 rounded-lg text-blue-600 mt-1">
             <FiInfo size={20} />
          </div>
          <div>
            <div className="font-bold text-blue-800 text-lg">सिस्टम</div>
            <div className="text-blue-600 text-sm font-medium">नवीन अपडेट उपलब्ध</div>
            <div className="text-blue-400 text-xs mt-1">v2.0.4 पहा</div>
          </div>
        </div>
      </div>

      {/* Notifications List */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        {/* Tabs */}
        <div className="flex border-b">
          <button 
            className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === 'unread' ? 'border-b-2 text-teal-700' : 'text-gray-500 hover:text-gray-700'}`}
            style={{ borderColor: activeTab === 'unread' ? colors.primary : 'transparent' }}
            onClick={() => setActiveTab('unread')}
          >
            न वाचलेले (Unread)
            <span className="ml-2 bg-red-100 text-red-600 px-2 py-0.5 rounded-full text-xs">२</span>
          </button>
          <button 
            className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === 'all' ? 'border-b-2 text-teal-700' : 'text-gray-500 hover:text-gray-700'}`}
            style={{ borderColor: activeTab === 'all' ? colors.primary : 'transparent' }}
            onClick={() => setActiveTab('all')}
          >
            सर्व (All)
          </button>
          <button 
            className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === 'archived' ? 'border-b-2 text-teal-700' : 'text-gray-500 hover:text-gray-700'}`}
            style={{ borderColor: activeTab === 'archived' ? colors.primary : 'transparent' }}
            onClick={() => setActiveTab('archived')}
          >
            संग्रहित (Archived)
          </button>
        </div>

        {/* List Content */}
        <div className="divide-y divide-gray-100">
          {filteredNotifications.length > 0 ? (
            filteredNotifications.map((notif) => (
              <div 
                key={notif.id} 
                className={`p-4 hover:bg-gray-50 transition-colors flex gap-4 ${notif.status === 'unread' ? 'bg-blue-50/30' : ''}`}
              >
                <div className={`mt-1 p-2 rounded-full bg-white shadow-sm h-10 w-10 flex items-center justify-center border ${getBorderColor(notif.type)}`}>
                  {getIcon(notif.type)}
                </div>
                
                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <h3 className={`text-sm font-medium mb-1 ${notif.status === 'unread' ? 'text-gray-900 font-bold' : 'text-gray-700'}`}>
                      {notif.message}
                    </h3>
                    <span className="text-xs text-gray-400 whitespace-nowrap ml-2">
                      {notif.date} | {notif.time}
                    </span>
                  </div>
                  <div className="flex justify-between items-end mt-1">
                    <p className="text-xs text-gray-500">
                      स्त्रोत: <span className="font-medium text-gray-700">{notif.gp}</span>
                    </p>
                    
                    <div className="flex gap-2">
                      {notif.status === 'unread' && (
                        <button className="text-xs flex items-center text-blue-600 hover:text-blue-800 transition-colors font-medium">
                          <FiCheck className="mr-1" /> वाचले (Mark Read)
                        </button>
                      )}
                      {notif.status !== 'archived' && (
                        <button className="text-xs flex items-center text-gray-500 hover:text-gray-700 transition-colors">
                          <FiArchive className="mr-1" /> संग्रहित करा (Archive)
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-8 text-center text-gray-500">
              <FiBell size={48} className="mx-auto mb-3 opacity-20" />
              <p>कोणत्याही नवीन सूचना नाहीत.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
